import {StorageFileType, StorageType} from '../../backend/enums';
import {
  StorageRequestResult,
  UserPictureStorageRequestData,
} from '../../backend/interfaces/storage-request';
import {PostStorageRequest} from '../../backend/requests/post-storage-request';
import {StorageRequestRepository} from '../../repositories/storage-request';

// Profile picture to upload
export const processProfilePicture = async (userId: string, file: File): Promise<string> => {
  // Request body
  const requestBodyProfilePictureFile: PostStorageRequest<UserPictureStorageRequestData> = {
    type: StorageType.UserPicture,
    fileType: StorageFileType.JPG,
    data: {
      userId: userId,
    },
  };

  // Some file was selected to be upload, request upload to the backend
  const storageProfilePictureRequestResult: StorageRequestResult<UserPictureStorageRequestData> =
    await StorageRequestRepository.instance.create<UserPictureStorageRequestData>(
      requestBodyProfilePictureFile
    );

  return await StorageRequestRepository.instance.upload<UserPictureStorageRequestData>(
    storageProfilePictureRequestResult,
    file
  );
};
